import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { AmelioHeader } from './AmelioHeader.tsx/AmelioHeader';
import { AmelioSidebar } from './AmelioSidebar/AmelioSidebar';

import { isPublicRoute } from '@/navigation/publicRoutes';

interface AmelioWrapperMockProps {
    children: React.ReactNode;
}

export const AmelioWrapperMock = ({ children }: AmelioWrapperMockProps) => {
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const isPublicPage = isPublicRoute(location.pathname);

    const toggleSidebar = useCallback(() => {
        setIsSidebarOpen((prev) => !prev);
    }, []);

    const closeSidebar = useCallback(() => {
        setIsSidebarOpen(false);
    }, []);

    return (
        <div
            className={'flex h-screen w-screen overflow-hidden'}
            data-testid={'amelio-wrapper-mock'}
        >
            {!isPublicPage && (
                <>
                    <AmelioSidebar
                        isOpen={isSidebarOpen}
                        onClose={closeSidebar}
                    />

                    <AmelioHeader onToggleSidebar={toggleSidebar} />
                </>
            )}

            {/* Main content area. The rail is `position: fixed` even at desktop widths — its
                `min-[1200px]:static` never applies, because this build's CSS emits the bare
                utility class after its responsive variants, so `fixed` (bare) always beats
                `static` (prefixed) in the same class chain. Reserving the rail's width here keeps
                every page from being cropped by it, without touching that pre-existing defect. */}
            <div
                id={'main-scroll-container'}
                className={`flex flex-1 flex-col items-center overflow-auto ${
                    isPublicPage ? '' : 'min-[1200px]:pl-[180px]'
                }`}
            >
                <main className={'w-full flex-1 px-5 py-24'}>{children}</main>
            </div>
        </div>
    );
};
